import {MspRegionPaymentActions, MspRegionPaymentActionTypes} from '../actions/region-msp-payment.actions';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialPaymentDistributorState: PaymentDistributorState = {
  Loaded: false,
  Loading: false,
  entities: null
};
export interface PaymentDistributorState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: null
};
export interface PaymentDocumentListState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialPaymentDocumentListState: PaymentDocumentListState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export interface PaymentDocumentState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialPaymentDocumentState: PaymentDocumentState = {
  Loaded: false,
  Loading: false,
  entities: null
};
export interface DeviceUsageListState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialDeviceUsageListState: DeviceUsageListState = {
  Loaded: false,
  Loading: false,
  entities: null
};

export interface DeviceUsageState {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialDeviceUsageState: DeviceUsageState = {
  Loaded: false,
  Loading: false,
  entities: null
};

// Get Msp Region Payment
export function reducer(state = initialState, action: MspRegionPaymentActions): State {
  switch (action.type) {
    case MspRegionPaymentActionTypes.GetMspRegionPayment:
      return {...state, Loaded: false, Loading: true};

    case MspRegionPaymentActionTypes.GetMspRegionPaymentSuccess:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case MspRegionPaymentActionTypes.GetMspRegionPaymentFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

// Get Msp Distributor Region Payment
export function reducerByDistributor(state = initialPaymentDistributorState, action: MspRegionPaymentActions): PaymentDistributorState {
  switch (action.type) {
    case MspRegionPaymentActionTypes.GetMspPaymentSettingByDistributor:
      return {...state, Loaded: false, Loading: true};

    case MspRegionPaymentActionTypes.GetMspPaymentSettingByDistributorSuccess:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case MspRegionPaymentActionTypes.GetMspPaymentSettingByDistributorFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

// Payment Document List
export function PaymentDocumentListReducer(state = initialPaymentDocumentListState, action: MspRegionPaymentActions): PaymentDocumentListState {
  switch (action.type) {
    case MspRegionPaymentActionTypes.ReadMspPaymentDocumentList:
      return {...state, Loaded: false, Loading: true};

    case MspRegionPaymentActionTypes.ReadMspPaymentDocumentListSuccess:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case MspRegionPaymentActionTypes.ReadMspPaymentDocumentListFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

// Payment Document
export function PaymentDocumentReducer(state = initialPaymentDocumentState, action: MspRegionPaymentActions): PaymentDocumentState {
  switch (action.type) {
    case MspRegionPaymentActionTypes.ReadMspPaymentDocument:
      return {...state, Loaded: false, Loading: true};

    case MspRegionPaymentActionTypes.ReadMspPaymentDocumentSuccess:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case MspRegionPaymentActionTypes.ReadMspPaymentDocumentFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

// Device Usage List
export function DeviceUsageListReducer(state = initialDeviceUsageListState, action: MspRegionPaymentActions): DeviceUsageListState {
  switch (action.type) {
    case MspRegionPaymentActionTypes.ReadMspDeviceUsageList:
      return {...state, Loaded: false, Loading: true};

    case MspRegionPaymentActionTypes.ReadMspDeviceUsageListSuccess:
    // return DeviceUsageListAdapter.upsertMany(action.payload, {...state, Loaded: true, Loading: false});
    return {...state, Loaded: true, Loading: false, entities: action.payload};

    case MspRegionPaymentActionTypes.ReadMspDeviceUsageListFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

// Device Usage
export function DeviceUsageReducer(state = initialDeviceUsageState, action: MspRegionPaymentActions): DeviceUsageState {
  switch (action.type) {
    case MspRegionPaymentActionTypes.ReadMspDeviceUsage:
      return {...state, Loaded: false, Loading: true};

    case MspRegionPaymentActionTypes.ReadMspDeviceUsageSuccess:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case MspRegionPaymentActionTypes.ReadMspDeviceUsageFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:
      return state;
  }
}

export const getMspRegionPaymentState = (state: State) => state;
export const getMspDistributorRegionPaymentState = (state: PaymentDistributorState) => state;
export const getMspPaymentDocumentListState = (state: PaymentDocumentListState) => state;
export const getMspPaymentDocumentState = (state: PaymentDocumentState) => state;
export const getMspDeviceUsageListState = (state: DeviceUsageListState) => state;
export const getMspDeviceUsageState = (state: DeviceUsageState) => state;
